import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import { VehicleDetails } from '../../../components/vehicle';
import Header from '../../../components/layouts/Header';
import IncludedExtras from '../components/accordions/IncludedExtras';
import ColourAndExtras from '../components/accordions/ColourAndExtras';
import Terms from './components/Terms';

import LeaseDetails from './components/LeaseDetails';
import AutoComplete from 'material-ui/AutoComplete';
import * as routes from '../../../routes/const';
import axios from 'axios';

import * as Api from '../../../api/const';

import { isEqual, debounce } from 'lodash';

import {
  NitroHeading,
  NitroNavBar,
  NitroDivider,
  NitroPanel,
  NitroLoading,
  NitroTextField
} from 'nitro-components';
import { ColumnContainer, ColumnSmall, ColumnLarge } from '../../../components/layouts/Columns';

import { getQuoteCreationCCAndCountry } from './selector';

const isValidPostcode = value => value && /^\d{4}$/.test(value);

const initState = {
  estimatedCost: null,
  dataSource: [],
  QuoteId: null,
  stateInfo: null,
  isLoading: false,
  isFetchingSuburbs: false,
  State: 'NSW',
  Postcode: null,
  formValid: false,
  AccidentManagement: null,
  FuelCard: null,
  Insurance: null,
  ReliefVehicle: null,
  Roadside: null,
  TollService: null,
  TyresIncluded: null
};

class CreateLease extends Component {
  constructor(props, context) {
    super(props, context);
    const cachedState = this.props.LeaseDetailsCache && this.props.LeaseDetailsCache.stateCache
      ? this.props.LeaseDetailsCache.stateCache
      : null;
    this.state = cachedState ? cachedState : initState;

    this.setEstimatedCost = this.setEstimatedCost.bind(this);
    this.nextHandler = this.nextHandler.bind(this);
  }
  componentWillMount() {
    if (!this.props.Term) {
      this.context.router.push(routes.CQ_CREATE_VEHICLE);
    } else {
      // once off logic to enhance state with preselected vehicle extras
      const extras = [
        'ReliefVehicle',
        'Roadside',
        'AccidentManagement',
        'Insurance',
        'TollService',
        'FuelCard',
        'TyresIncluded'
      ];

      const { selectedVehicle } = this.props;
      // console.log('preselected extras');
      extras.forEach(extra => {
        const item = selectedVehicle[extra];
        const data = item.map((v, i) => {
          // if (stateCache[extra]) console.log(`state cache & api data for ${extra}`, stateCache[extra], v, stateCache[extra].key === v.Key)
          return { key: v.Key, Value: v.Value, IsSelected: v.IsSelected };
        });
        const filterData = data.filter(d => d.key !== 'NONE');
        const selectedData = filterData.filter(d => d.IsSelected === true)[0];

        if (filterData.length === 1 && selectedData) {
          // console.log(extra, selectedData);
          this.setState({
            [extra]: {
              key: selectedData.key,
              value: selectedData.Value,
              extra: extra.replace(/([a-z](?=[A-Z]))/g, '$1 ')
            }
          });
        }
      });
    }
  }

  componentDidMount() {
    const { updateStep } = this.props.actions;

    if (this.props.Term) {
      updateStep(2);
      this.updateQuote();
    }
  }

  setEstimatedCost(event, isInputChecked, priceNet) {
    let estimatedCost = 0;

    if (isInputChecked) {
      estimatedCost = this.state.estimatedCost + priceNet * 0.5;
    } else {
      estimatedCost = this.state.estimatedCost - priceNet * 0.5;
    }
    this.setState({
      estimatedCost: estimatedCost
    });
  }

  updateQuote = () => {
    // console.log('new state', this.state);
    const validCheck = this.state.stateInfo ? /\d{4}/.exec(this.state.stateInfo) : true;

    // console.log('props', this.props);
    const { exteriorColour, selectColour, selectedExtras, selectedVehicle, deliveryDetails } = this.props;

    // console.log(exteriorColour, selectColour, selectedExtras);
    const exteriorColourCode = selectColour.Key;
    // exteriorColour && exteriorColour.find(data => data.Value === selectColour).Key;
    const VehicleOptions = selectedExtras.map(data => data.code);
    // console.log(exteriorColourCode, VehicleOptions);

    const payloadCache = {
      ReliefVehicleCode: this.state.ReliefVehicle,
      RoadsideCode: this.state.Roadside,
      AccidentManagementCode: this.state.AccidentManagement,
      InsuranceCode: this.state.Insurance,
      RegistrationState: this.state.State || selectedVehicle.State,
      RegistrationPostalCode: this.state.Postcode,
      TollServiceCode: this.state.TollService,
      FuelCardService: this.state.FuelCard,
      TyresIncludedCode: this.state.TyresIncluded
      // stateCache: this.state
    };

    const payload = {
      QuoteId: this.state.QuoteId ? this.state.QuoteId : null,
      QuestionAnswerSession_Id: this.props.vehicles.QuestionAnswers_Id,
      VariantId: this.props.selectedVehicle.VariantId,
      QuoteTemplateId: this.state.QuoteId ? null : this.props.selectedVehicle.QuoteTemplateId,
      EmployerCode: null,
      CountryCode: this.props.country.value,
      // CompanyCode: this.props.costcenter.value,
      CostCenterCode: (this.props.restrictionCostCenter) ? this.props.restrictionCostCenter.value: '',
      Term: this.props.Term,
      Distance: this.props.Distance,
      ExteriorColourCode: exteriorColourCode,
      InteriorColourCode: null,
      ReliefVehicleCode: this.state.ReliefVehicle ? this.state.ReliefVehicle.key : null,
      RoadsideCode: this.state.Roadside ? this.state.Roadside.key : null,
      MaintenanceType: null,
      FuelCardService: this.state.FuelCard ? this.state.FuelCard.key : null,
      AccidentManagementCode: this.state.AccidentManagement ? this.state.AccidentManagement.key : null,
      InsuranceCode: this.state.Insurance ? this.state.Insurance.key : null,
      RegistrationState: this.state.State || selectedVehicle.State,
      RegistrationPostalCode: this.state.Postcode,
      Notes: null,
      TollServiceCode: this.state.TollService ? this.state.TollService.key : null,
      TyresIncludedCode: this.state.TyresIncluded ? this.state.TyresIncluded.key : null,
      VehicleOptions: VehicleOptions,
      ...deliveryDetails
    };

    // console.log('payload', payload);

    if (validCheck) {
      this.setState({
        isLoading: true
      });

      axios
        .post(`${Api.getAPIRoot()}/fleet/corporatequote/updateQuote`, payload)
        .then(response => response.data)
        .then(data => {
          // console.log(data);
          // alert(JSON.stringify(data.data, null, 2));
          this.setState({
            isLoading: false,
            QuoteId: data.data.QuoteId,
            estimatedCost: data.data.NetPrice,
            payloadCache: payloadCache
          });
          return data;
        })
        .catch(error => {
          throw error;
        });
    }
  };

  updateOrUnsetValue = (stateName, value, componentType) => {
    if (componentType === 'ButtonSelectGroup' && this.state[stateName] && isEqual(this.state[stateName], value)) {
      return null;
    } else if (!value.key) {
      return null;
    } else {
      return value;
    }
  };

  termDetailUpdate = data => {
    this.setState(
      {
        [data.termId]: this.updateOrUnsetValue(
          [data.termId],
          {
            key: data.key,
            value: data.Value,
            extra: data.termId.replace(/([a-z](?=[A-Z]))/g, '$1 ')
          },
          data.componentType
        )
      },
      this.updateQuote
    );
  };

  getPostCode = debounce((value, cbSuccess, cbErr) => {

    const isValid = this.formValidation(value, true);

    if (!isValid) {
      this.setState({
        formValid: isValid,
        postcodeError: !isValid && value ? 'Invalid postcode' : null,
      });
      return;
    }

    this.setState({
      dataSource: [],
      isFetchingSuburbs: true,
    });

    axios
      .get(`${Api.getAPIRoot()}/geocode/getAddress/${value}`)
      .then(response => response.data)
      .then(data => {
        cbSuccess(data);
      })
      .catch(error => {
        cbErr();
      });
  }, 300)

  handlePostcodeInput = value => {

    this.setState({
      stateInfo: value
    });

    const cbSuccess = (data) => {
      this.setState({
        formValid: true,
        isFetchingSuburbs: false,
        dataSource: data.data
      });
    }

    const cbErr = () => {
      this.setState({
        formValid: false,
        isFetchingSuburbs: false,
        postcodeError: 'Unable to find a suburb'
      });
    }

    if(value.length == 4)
      this.getPostCode(value, cbSuccess, cbErr)

  };

  formValidation = (input, exactMatch) => {
    // Check input contains (or is) a postcode
    const formValid = exactMatch ? isValidPostcode(input) : input && /\d{4}/.test(input);
    return formValid;
  };

  handleStateInfoChange = (stateInfo, idx) => {
    const formValid = this.formValidation(stateInfo.Postcode);

    if (!formValid) {
      return;
    }

    this.setState(
      {
        formValid: formValid,
        State: stateInfo.State,
        Postcode: stateInfo.Postcode,
        stateInfo: stateInfo.Postcode,
      },
      this.updateQuote
    );
  };

  nextHandler = () => {
    const { setEstimatedCost, setQuoteId, setLeaseDetails } = this.props.actions;
    setEstimatedCost(this.state.estimatedCost);

    setQuoteId(this.state.QuoteId);
    console.log(this.state);
    const { payloadCache, ...others } = this.state;
    console.log(payloadCache);
    console.log(others);

    setLeaseDetails({ ...payloadCache, stateCache: { ...others } });

    if (this.state.formValid) this.context.router.push(routes.CQ_CREATE_DELIVERY);
  };

  render() {
    const { selectedVehicle, options, selectedExtras, selectColour } = this.props;

    return (
      <section>

        <Header margin="32px 0" lineHeight={32}>
          <NitroNavBar
            actionOnHeading
            label="Back to options selection"
            action={() => this.context.router.push(routes.CQ_CREATE_OPTIONS)}
            float
            lineHeight={26}
            noPadding
          />
          <NitroHeading label="Lease" align="center" size="1" />
        </Header>

        <ColumnContainer>
          <ColumnSmall>
            <NitroPanel>
              <VehicleDetails disablePanelClick {...selectedVehicle} />
              <NitroDivider />
              <IncludedExtras options={options} />
              <NitroDivider />
              <ColourAndExtras selectedColour={selectColour} selectedExtras={selectedExtras} active />
            </NitroPanel>
          </ColumnSmall>

          <ColumnLarge style={{ marginBottom: '100px' }}>
            <NitroPanel>
              <NitroHeading size="2" label="Registration Suburb" noMargin />
              {this.state.isLoading &&
              <NitroTextField
              value={this.state.stateInfo || ''}
              disabled
              fullWidth
            />}
              {!this.state.isLoading &&
              <AutoComplete
                openOnFocus
                errorText={this.state.postcodeError}
                dataSource={this.state.dataSource} // {this.props.registerAddresses}
                dataSourceConfig={{ text: 'FormattedAddress', value: 'Postcode'}}
                searchText={this.state.stateInfo || ''}
                onUpdateInput={this.handlePostcodeInput}
                onNewRequest={this.handleStateInfoChange}
                floatingLabelText="Enter your postcode"
                hintText="Enter your postcode"
                fullWidth
              />}

            </NitroPanel>
            {this.state.isFetchingSuburbs && (
              <NitroLoading />
            )}

            {this.state.formValid && this.state.State && this.state.Postcode &&
              <LeaseDetails
                vehicle={selectedVehicle}
                stateCache={this.state}
                clickHandler={this.termDetailUpdate}
                isLoading={this.state.isLoading}
              />
            }

          </ColumnLarge>
        </ColumnContainer>

        {this.props.Term &&
          <Terms
            calculating={this.state.isLoading}
            vehicle={selectedVehicle}
            estimatedCost={this.state.estimatedCost}
            disabled={this.state.isLoading || !this.state.stateInfo || !this.state.formValid}
            actionHandler={this.nextHandler}
            term={this.props.Term}
            distance={this.props.Distance}
          />}

      </section>
    );
  }
}

CreateLease.propTypes = {
  deliveryDetails: PropTypes.object,
  vehicles: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,


  selectedVehicle: PropTypes.object.isRequired,
  selectedExtras: PropTypes.array,
  LeaseDetailsCache: PropTypes.object,
  exteriorColour: PropTypes.array,
  selectColour: PropTypes.object,
  Term: PropTypes.string,
  Distance: PropTypes.string
};

//Pull in the React Router context so router is available on this.context.router.
CreateLease.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  // extract the relevent parts of the state you need for this view
  const { create } = state.corporateQuote;
  const { restrictionCostCenter } = state.corporateQuote.create;

  return {
    deliveryDetails: create.deliveryDetails,
    vehicles: create.vehicles,
    options: create.options,
    selectedExtras: create.selectedExtras,
    exteriorColour: create.selectedVehicle.ExteriorColour,
    selectedVehicle: create.selectedVehicle,
    Term: create.selectedTerms ? create.selectedTerms.Term : null,
    Distance: create.selectedTerms ? create.selectedTerms.Distance : null,
    selectColour: create.selectedColour,
    LeaseDetailsCache: create.leaseDetails,
    ...getQuoteCreationCCAndCountry(state),
    restrictionCostCenter,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateLease);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/CreateLease.js